import UserTaskApiAgency from '@/api/UserTaskApiAgency';

class TaskService implements ResourceService {
	private get api () { return UserTaskApiAgency; }

	async storeAsync (payload: IAddUserTaskModel) {
		const { data } = await this.api.add(payload);
		return data;
	}

	async getAsync () {
		throw new Error('Method not implemented.');
	}

	async updateAsync (id: number, payload: IUpdateUserTaskModel) {
		const { data } = await this.api.update(id, payload);
		return data;
	}

	async deleteAsync (id: number) {
		await this.api.delete(id);
	}
}

const taskServiceSingleton = new TaskService();

export default function useTaskService () {
	return taskServiceSingleton;
}
